import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";

import "hammerjs";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// main.ts re-executes on every HMR update; guard against re-initializing Sentry
// (and re-creating the Replay integration), which otherwise throws
// "Multiple Sentry Session Replay instances are not supported" and forces a full reload.
if (!(window as any).__sentryInitialized) {
  Sentry.init({
    dsn: "https://078dd7cdf6f1706c9e14eda70eae9f44@o4508962573254656.ingest.us.sentry.io/4508962576596992",
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        mutationBreadcrumbLimit: 30000,
        mutationLimit: 40000,
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: environment.production ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  (window as any).__sentryInitialized = true;
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if ("serviceWorker" in navigator) {
      // Register custom service worker for push notifications
      // This handles push events and notification clicks with proper routing
      navigator.serviceWorker
        .register("/custom-sw.js", { scope: "/" })
        .then((registration) => {
          console.log("Custom service worker registered:", registration);
        })
        .catch((error) => {
          console.error("Service worker registration failed:", error);
        });
    }
  })
  .catch((err) => console.log(err));
